module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "d7e4848"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_toc_r1#d7e2776",
      "id": "d14e303"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OREWORD ")])])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    staticStyle: {
      "margin-top": "-5.7em"
    },
    attrs: {
      "id": "d14e306"
    }
  }, [_c('i', [_vm._v("by Shimon Peres")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e4928"
    }
  }, [_vm._v("Before you is a book written by the most Jewish Jew of the last decades. This is a book on Judaism, its glory and ordeals, depicting a period that could possibly be judged as the hardest, bitterest, and darkest in the annals of the Jewish people. This is a book that portrays the persona of the writer alongside the traits of his Jewish people. This is a book whose every word has been inscribed in blood.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e5138"
    }
  }, [_vm._v("Inspired by the stirring words of our national poet, Chaim Nachman Bialik, “Should you wish to know the Source, / From which your brothers drew … / Their strength of soul … / Their comfort, courage, patience, trust, / And iron might to bear their hardships / And suffer without end or measure?” I conclude that "), _c('i', [_vm._v("Out of the Depths")]), _vm._v(" constitutes this very source.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e5388"
    }
  }, [_vm._v("As we read this book—in which the writer, Rabbi Israel Meir Lau, charts the twists and turns of his life in the Diaspora and in Israel—it is hard to make out the words, for our eyes have misted over, brimming with tears, as we are exposed to spine-chilling depictions, to words that hide a painful, soul-wrenching narrative. The silent words cry out to us. The probing questions remain unanswered to the bitter end.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e5709"
    }
  }, [_vm._v("In the words of King Solomon, I wish Rabbi Israel Meir Lau, the State of Israel, and the Jewish people “length of days, and long life, and peace, shall they add to thee” and all the house of Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e5819"
    }
  }, [_vm._v("May this book serve as a pillar of fire for us all, whatever road we take.")]), _vm._v(" "), _c('p', {
    staticClass: "txr14",
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "id": "d7e5929"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("—SHIMON PERES ")]), _c('br'), _vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESIDENT OF THE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TATE OF ")]), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SRAEL ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-289b97b1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Auth_ISBN9781402790959_epub_c7_r1.vue
// module id = 75
// module chunks = 0